import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateShift } from '../../../redux/shifts/shiftsThunks';

/**
 * Hook to manage shift notes operations
 *
 * @param {Object} params
 * @param {string} params.shiftID - The ID of the shift
 * @param {Object} params.shift - The shift object
 * @returns {Object} Object containing notes state and handlers
 */
export const useShiftNotes = ({ shiftID, shift }) => {
  const dispatch = useDispatch();
  const [updatedNotes, setUpdatedNotes] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing && shift?.notes !== undefined && shift.notes !== updatedNotes) {
      setUpdatedNotes(shift.notes);
    }
  }, [shift?.notes, isEditing, updatedNotes]);

  const handleSaveNote = useCallback(
    (note) => {
      if (!shiftID) return;
      setUpdatedNotes(note);
      setIsEditing(true);
    },
    [shiftID]
  );

  const handleNoteBlur = useCallback(
    (event) => {
      const note = event.target.value;
      setIsEditing(false);
      if (note !== shift?.notes) {
        dispatch(
          updateShift({
            shiftId: shiftID,
            updatedFields: { notes: note },
          })
        );
      }
    },
    [dispatch, shiftID, shift?.notes]
  );

  return {
    updatedNotes,
    handleSaveNote,
    handleNoteBlur,
  };
};
